<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    useredit: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dataTitle: [
        {
          title: 'reservationRelation',
          value: '',
          key: 'reservation_relation',
        },
        {
          title: 'deviceName',
          value: '',
          key: 'device_name',
        },
        {
          title: 'contractorName',
          value: '',
          key: 'contractor_name',
          validate: [(v) => v.length <= 255 || 'max length 255'],
        },
        {
          title: 'reservationPage',
          value: '',
          key: 'page_booking',
          validate: [(v) => v.length <= 255 || 'max length 255'],
        },
        {
          title: 'menu',
          value: '',
          key: 'menu',
          validate: [(v) => v.length <= 255 || 'max length 255'],
        },
        {
          title: 'option',
          value: '',
          key: 'option',
          validate: [(v) => v.length <= 255 || 'max length 255'],
        },
      ],
      isShow: false,
    }
  },
  computed: {
    computedOpenDialog() {
      return this.dialog
    },
  },
  watch: {
    useredit() {
      this.dataTitle = this.dataTitle?.map((item) => {
        if (item.key === 'reservation_relation') {
          this.isShow = this.useredit[item.key]
        }
        item.value = this.useredit[item.key]
        return item
      })
    },
  },
  methods: {
    closeDialog() {
      return this.$emit('closeDialog', false)
    },
    editUser() {
      const id = this.useredit.device_id
      if (!this.$refs.form.validate()) {
        return this.$emit('closeDialog', true)
      }
      const user = {}
      this.dataTitle.forEach((item) => {
        user[item.key] = item.value
      })
      Object.assign(user, { device_id: id })
      return this.$emit('handleSubmitEditUser', false, user)
    },
    onChange(event) {
      this.isShow = event
    },
  },
}
</script>

<template>
  <v-dialog
    v-model="computedOpenDialog"
    width="450"
    overlay-color="#ffffff"
    content-class="round_dialog_edit"
    @click:outside="closeDialog"
  >
    <v-card color="#adc8e8">
      <v-card-title
        class="text-h5 mb-7 lighten-2 justify-center font-weight-bold"
      >
        {{ $t('informEditing') }}
      </v-card-title>
      <v-form
        id="edit-form"
        ref="form"
        class="ml-7 mr-7"
        @submit.prevent="editUser"
      >
        <v-container>
          <v-row v-for="(item, i) in dataTitle" :key="`group-${i}`">
            <v-col cols="12" sm="12" md="4" class="font-weight-bold">
              {{ $t(item.title) }}
              <span v-if="item.require" class="color_red">*</span>
            </v-col>
            <v-col
              v-if="item.key === 'reservation_relation'"
              cols="12"
              sm="12"
              md="8"
            >
              <v-switch
                v-model="item.value"
                dense
                inset
                class="ma-0 pa-0"
                @change="onChange"
              ></v-switch>
            </v-col>
            <v-col
              v-else-if="item.key === 'device_name'"
              cols="12"
              sm="12"
              md="8"
            >
              <v-text-field
                v-model="item.value"
                outlined
                disabled
                color="black"
                background-color="white"
                dense
                :rules="item.validate"
                hide-details="auto"
              />
            </v-col>
            <v-col v-else cols="12" sm="12" md="8">
              <v-text-field
                v-model="item.value"
                outlined
                :disabled="!isShow"
                color="black"
                background-color="white"
                dense
                :rules="item.validate"
                hide-details="auto"
                maxlength="255"
              />
            </v-col>
          </v-row>
          <v-row class="mt-7 pb-5">
            <v-col class=" d-flex justify-center">
              <v-card-actions>
                <v-btn
                  color="primary"
                  class="white--text custom_height custom_width mr-5"
                  type="submit"
                >
                  OK
                </v-btn>
              </v-card-actions>
              <v-card-actions>
                <v-btn
                  color="grey"
                  class="white--text custom_height"
                  type="button"
                  @click="closeDialog"
                >
                  {{ $t('cancel') }}
                </v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<style lang="scss">
@import '@design';
.round_dialog_edit {
  border-radius: 20px !important;
}
#edit-form {
  .custom_width {
    width: 100px !important;
  }
  .custom_height {
    height: 32px !important;
  }
}
</style>
